// extracted by mini-css-extract-plugin
export var content = "_4d-3";
export var list = "_4d-4";
export var settingsContent = "_4d-7";
export var settingsPanel = "_4d-8";
export var state = "_4d-6";
export var triggerBadge = "_4d-2";
export var triggerButton = "_4d-1";
export var triggerShell = "_4d-0";
export var unreadDot = "_4d-5";